import React, { FC } from 'react';
import './index.css';

const Alert: FC = () => {
  return <div className="copy-modal-window hidden">Copied To Clipboard</div>;
};

export default Alert;
